import styled from "@emotion/styled";
import { ToolsSidebar } from "./tools-sidebar";
import { Browser } from "./browser";
import { SwitchPlatformButton } from "./common/switch-platform-button";
import { useEffect, useState } from "react";
import { Mobile } from "./mobile";
import { useTranslation } from 'react-i18next'

const SwitchContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
  cursor: pointer;
`;

export const Container = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-y: auto;
`;

export const Styling = () => {
  const [platform, setPlatform] = useState<"DESKTOP" | "MOBILE">("DESKTOP");
  const { t } = useTranslation()

  useEffect(() => {
    return () => {
      localStorage.removeItem("customTheme")
    }
  }, [])

  return (
    <>
      <Container>
        <SwitchContainer>
          <SwitchPlatformButton
            icon="Monitor"
            text={t('styles.desktop')}
            active={platform === "DESKTOP"}
            onClick={setPlatform.bind(null, "DESKTOP")}
          />
          <SwitchPlatformButton
            icon="DeviceMobileCamera"
            text={t('styles.mobile')}
            active={platform === "MOBILE"}
            onClick={setPlatform.bind(null, "MOBILE")}
          />
        </SwitchContainer>
        {platform === "DESKTOP" && <Browser />}
        {platform === "MOBILE" && <Mobile />}
      </Container>
      <ToolsSidebar />
    </>
  );
};
